export default "__VITE_PUBLIC_ASSET__8a1dc31d__"